import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Box, IconButton } from '@mui/material'

import { useReportList } from '../../reports/services/ReportsHooks'
import ReportPlaceholder from '../../reports/viewer/ReportPlaceholder'
import ReportViewer from '../../reports/viewer/ReportViewer'
import { Report } from '../../types'

const BiReports = ({ nameList }: { nameList: string[] }) => {
  const { reports } = useReportList()

  let filteredReports = reports?.filter((report) => nameList.some((n) => report.description?.includes(n)))
  if (!filteredReports || filteredReports.length === 0) {
    filteredReports = reports?.filter((report) => nameList.some((n) => report.name.includes(n)))
  }
  if (filteredReports && filteredReports.length > 1) {
    filteredReports = filteredReports.slice(0, 1)
  }

  if (!filteredReports || filteredReports.length === 0) {
    return <ReportPlaceholder />
  }

  const handleOpenInNewTab = (report: Report) => {
    const reportUrl = `/reports/${report.workspaceId}/${report.id}`
    window.open(reportUrl, '_blank')
  }

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          border: '1px solid #ccc',
          borderTop: 'none',
        }}
      >
        {filteredReports.map((report) => (
          <Box key={report.id} sx={{ height: '100%', position: 'relative', '&:hover .openInNew-icon': { opacity: 1 } }}>
            <ReportViewer
              reportId={report.id}
              workspaceId={report.workspaceId}
              settings={{ navContentPaneEnabled: false }}
            />
            <IconButton
              onClick={() => handleOpenInNewTab(report)}
              sx={{
                position: 'absolute',
                top: 10,
                right: 10,
                opacity: 0,
                transition: 'opacity 0.3s',
                '&:hover': {
                  opacity: 1,
                },
              }}
              className="openInNew-icon"
            >
              <OpenInNewIcon fontSize="inherit" />
            </IconButton>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default BiReports
